import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Calibration_Interface, Empty_Calibration_Interface } from 'src/app/Interface/Calibration_Interface';
import { FeildActivity_Interface } from 'src/app/Interface/FeildActivity_Interface';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CalibrationService } from 'src/app/Service/Calibration/Calibration.service';
import { ExpirationService } from 'src/app/Service/Expiration/Expiration.service';

@Component({
  selector: 'app-DataEntityDeviceInfo',
  templateUrl: './DataEntityDeviceInfo.component.html',
  styleUrls: ['./DataEntityDeviceInfo.component.scss']
})
export class DataEntityDeviceInfoComponent implements OnInit {

  Calibration_Device: Calibration_Interface = Empty_Calibration_Interface();

  @Input() inner_calibration_id: number = 0
  @Output() outter_Calibration_Device = new EventEmitter<Calibration_Interface>();

  constructor(
    private Calibration_Service: CalibrationService,
    private Expiration_Service: ExpirationService,
    private Alertify_Service: AlertifyService,
    private modalService: BsModalService
  ) { }

  ngOnInit() {
    this.Read_Calibration()
  }


  Read_Calibration() {
    this.InProccessing = true
    this.Calibration_Service.GetSingleCalibrationDetail(this.inner_calibration_id
    ).subscribe(
      (data) => {
        this.Calibration_Device = data;
        this.outter_Calibration_Device.emit(this.Calibration_Device);
        this.Read_Expiration()
      },
      (error) => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    );
  }


  Datalist_Expiration: Array<FeildActivity_Interface> = []
  Read_Expiration() {
    this.Expiration_Service.GetActiveAndId(this.Calibration_Device.expiration).subscribe(
      (data) => {
        this.Read_RelativeDeviceName()
        this.Datalist_Expiration = data;
        this.InProccessing = false
      },
      (error) => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    );
  }


  InProccessing: boolean = false
  SubmitCalibration() {
    this.InProccessing = true
    this.Calibration_Service.SubmitCalibrationCertification(this.inner_calibration_id,
      this.Calibration_Device.priod,
      this.Calibration_Device.expert_off,
      this.Calibration_Device.device_code,
      this.Calibration_Device.device_serial,
      this.Calibration_Device.expiration).subscribe(
        data => {
          this.InProccessing = false
          this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
          this.outter_Calibration_Device.emit(this.Calibration_Device)
        },
        (error) => {
          // AuthInterceptor owns authentication; feature errors must preserve credentials.
        }
      )
  }

  //#region RelativeDeviceName
  Dsc_RelativeDevice:string=''
  DataList_RelativeDevice: Array<General_Interface> = []
  Read_RelativeDeviceName() {
    this.Calibration_Service.GetCalibrationRelativeDeviceName(this.inner_calibration_id).subscribe(
      (data) => {
        this.DataList_RelativeDevice = data;
        this.InProccessing = false
      },
      (error) => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    );
  }
  modalRef_RelativeDeviceName: any
  openModal(template: TemplateRef<any>) {
    this.Dsc_RelativeDevice=""
    this.modalRef_RelativeDeviceName = this.modalService.show(template);
  }

  SubmitCalibrationCertificationDevicename(item:General_Interface)
  {
    if(!this.Dsc_RelativeDevice)
    {
      this.Alertify_Service.ErrorMessage("شرح درخواست را وارد نمائید")
    }
    else{
    this.modalRef_RelativeDeviceName.hide()
    this.Calibration_Service.SubmitCalibrationCertificationDevicename(this.inner_calibration_id,
      item.title+'',
      this.Dsc_RelativeDevice).subscribe(
        data=>{
          if(data['id']==-1)
            this.Alertify_Service.ErrorMessage("درخواست فعال برای تغییر نام وجود دارد")
          else if (data['id'] == -2) {
            this.Alertify_Service.ErrorMessage("گردش کار فعالی برای درخواست تغییر نام دستگاه انتخاب نشده است")
          }
          else if (data['id'] == -3) {
            this.Alertify_Service.ErrorMessage("خطا سیستمی")
          }
          else if (data['id'] == -4) {
            this.Alertify_Service.ErrorMessage("در چارت سازمانی بدون سمت هستید")
          }
          else
            this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
        }
      )
    }
  }


  //#endregion

}
